import { useEffect } from "react";
import { ConfigProvider, App } from "antd";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/zh-cn";
import Routes from "./routes";
import { publicArea } from "./utils/api/common";
import { RootState, AppDispatch } from "./app/store";
import { setCountry } from "./app/reducers/countrySlice";
import { asyncPublicCurrency } from "@/app/reducers/headerSlice";
import { LoadingWrap } from "@/component/loading";

dayjs.extend(updateLocale);

const localeConfig = { zh: zhCN, en: enUS };

// 延迟到下一个微任务执行（不阻塞当前事件循环的首屏渲染）
const defer = (fn: () => void) => {
  if (typeof queueMicrotask !== 'undefined') queueMicrotask(fn);
  else Promise.resolve().then(fn);
};

export default function Index() {
  const dispatch = useDispatch<AppDispatch>();
  const { value: lang } = useSelector((state: RootState) => state.lang);

  useEffect(() => {
    const loadGlobalData = () => {
      const getCountry = async () => {
        const { data: { data, code }, } = await publicArea({ pid: 0 });
        if (+code === 0) {
          dispatch(setCountry((data as { list: object[] }).list));
        }
      };
      getCountry();

      dispatch(asyncPublicCurrency());
    };

    defer(loadGlobalData);

  }, [dispatch]);

  return (
    <ConfigProvider locale={localeConfig[lang as keyof typeof localeConfig]} theme={{ token: { colorPrimary: "#D60505", controlHeight: 40 } }}>
      <App message={{ maxCount: 3 }}>
        <Routes />
        <LoadingWrap />
      </App>
    </ConfigProvider>
  );
}